import React, { useState, Fragment, useEffect } from "react";
import Checkbox from "./CheckBox";
import { IconBottom } from "../icons";

const breakPoint = 768;

const TableRimac = ({
  TC_setGlobalCheked,
  TC_globalCheked,
  TC_tableColumns,
  TC_list,
  TC_handleChangeCheckBox,
  TC_handleOrderData,
  TC_hasCheckbox = true,
  TC_hasPages = true,
  TC_hasIndex = true,
}) => {
  // const MobileScreen = window.matchMedia('(max-width: 768px)').matches
  const [order, setOrder] = useState(true);
  const [MobileScreen, setMobileScreen] = useState(false);
  const orderData = (columnName, sortCriteria) => {
    let newListCurrent = [...TC_list].sort((a, b) => {
      let value_a;
      let value_b;
      value_a = a[columnName];
      value_b = b[columnName];
      if (sortCriteria) {
        value_a = sortCriteria(a);
        value_b = sortCriteria(b);
      }
      if (value_a > value_b) {
        return order ? -1 : 1;
      }
      if (value_a < value_b) {
        return order ? 1 : -1;
      }
      return 0;
    });
    setOrder(!order);
    TC_handleOrderData(newListCurrent);
  };

  useEffect(() => {
    const handleResize = () => {
      let widthScreen = window.innerWidth;
      setMobileScreen(widthScreen < breakPoint ? true : false);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const ResponsiveTableColumns = TC_tableColumns.filter(
    (item) => item.ResOrder
  ).sort((a, b) => (a.ResOrder < b.ResOrder ? -1 : 1));

  if (MobileScreen) {
    return (
      <div className="ContainerTableRimacResponsive">
        {TC_hasCheckbox && (
          <div
            className="MarcarTodos"
            onClick={() => TC_setGlobalCheked(!TC_globalCheked)}
          >
            <p className="title-07">Marcar Todos</p>{" "}
            <Checkbox checked={TC_globalCheked} />
          </div>
        )}
        {TC_list &&
          TC_list.map((row, index) => (
            <div key={index}>
              <div className="row">
                <input type="checkBox" id={`${index}acc`}></input>
                <div className="row__content">
                  <div
                    className="checkBox"
                    onClick={() =>
                      TC_hasCheckbox && TC_handleChangeCheckBox(index)
                    }
                  >
                    <p className="title-07">Nº {index + 1}</p>
                    {TC_hasCheckbox && <Checkbox checked={row.checked} />}
                  </div>
                  {ResponsiveTableColumns &&
                    ResponsiveTableColumns.map((colum, index2) => (
                      <div className="item" key={index2}>
                        <div className="item__title title-07">
                          {colum.Title}
                        </div>
                        <div key={index2} className="item__value paragraph-12">
                          {colum.Special
                            ? colum.Special(row, index)
                            : colum.Characters
                            ? (row[colum.RowName] || '').substring(0, colum.Characters || 10)
                            : (row[colum.RowName] || '')}
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          ))}
      </div>
    );
  } else {
    return (
      <table className="ContainerTableRimac">
        <thead>
          <tr className="title-08">
            {TC_hasCheckbox && (
              <th key={0} onClick={() => TC_setGlobalCheked(!TC_globalCheked)}>
                <Checkbox checked={TC_globalCheked} />
              </th>
            )}
            {TC_hasIndex && <th key={1}>N</th>}
            {TC_tableColumns &&
              TC_tableColumns.map((colum, index) => (
                <th
                  key={index}
                  onClick={() => orderData(colum.RowName, colum.SortCriteria)}
                >
                  {colum.Title}
                </th>
              ))}
          </tr>
          <tr>
            <th
              className="borde_inferior"
              colSpan={TC_tableColumns.length + 2}
            ></th>
          </tr>
        </thead>
        <tbody>
          {TC_list && TC_list.length > 0 ? (
            TC_list.map((row, index) => (
              <Fragment key={index}>
                {TC_hasPages && index % 10 === 0 && (
                  <tr
                    key={`10_${index}`}
                    className="pagina"
                    id={`pagina_${index / 10 + 1}`}
                  >
                    <td
                      key="10_00"
                      className="title-07"
                      colSpan={TC_tableColumns.length + 2}
                    >
                      PAGINA {index / 10 + 1}
                    </td>
                  </tr>
                )}
                <tr className="paragraph-12">
                  {TC_hasCheckbox && (
                    <td
                      onClick={() => {
                        TC_hasCheckbox && TC_handleChangeCheckBox(index);
                      }}
                    >
                      <Checkbox checked={row.checked} />
                    </td>
                  )}

                  {TC_hasIndex && <td>{index + 1}</td>}
                  {TC_tableColumns &&
                    TC_tableColumns.map((colum, index2) => (
                      <td
                        key={index2}
                        className={colum.RightLine ? "rightLine" : ""}
                      >
                        {colum.Special
                          ? colum.Special(row, index)
                          : colum.Characters
                          ? (row[colum.RowName] || '').substring(0, colum.Characters || 10)
                          : (row[colum.RowName] || '')}
                      </td>
                    ))}
                </tr>
              </Fragment>
            ))
          ) : (
            <tr>
              <td colSpan={TC_tableColumns.length} className="paragraph-12">
                No se encontraron datos para mostrar
              </td>
            </tr>
          )}
        </tbody>
      </table>
    );
  }
};
export default TableRimac;
